import styled from "@emotion/styled";
import Button from "@mui/material/Button";

const MediumButton = styled(Button)({
    width: '100%',
    minHeight: '80px',
    maxHeight: '80px'
});

export default MediumButton;